export function TechSubgroup({
  title,
  children,
}: {
  title?: string;
  children?: React.ReactNode;
}) {
  return (
    <div className="flex items-center gap-1">
      {title && <div className="text-xs text-text-muted">{title}</div>}
      <div className="flex gap-1 p-0.5 rounded-lg bg-secondary">{children}</div>
    </div>
  );
}
